var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3497"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "30-filters"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3376",
    stroke: "#2c271c",
    transform: "translate(-6 -7.559)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 137",
    fill: "none",
    strokeLinecap: "round",
    d: "M6.5 10.059h13"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 9",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(9 8.059)",
    fill: "#e7b940"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "30-filters"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3376",
    stroke: "#2c271c",
    transform: "translate(.5 6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 137",
    fill: "none",
    strokeLinecap: "round",
    d: "M13 2H0"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 9",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(6.5)",
    fill: "#e7b940"
  }))))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDE0IDExIj4KICA8ZyBpZD0iR3JvdXBfMzQ5NyIgZGF0YS1uYW1lPSJHcm91cCAzNDk3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTUgLTIzLjUpIj4KICAgIDxnIGlkPSJfMzAtZmlsdGVycyIgZGF0YS1uYW1lPSIzMC1maWx0ZXJzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5IDE1Ljk0MSkiPgogICAgICA8ZyBpZD0iR3JvdXBfMzM3NiIgZGF0YS1uYW1lPSJHcm91cCAzMzc2Ij4KICAgICAgICA8bGluZSBpZD0iTGluZV8xMzciIGRhdGEtbmFtZT0iTGluZSAxMzciIHgyPSIxMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNi41IDEwLjA1OSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzJjMjcxYyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjEiLz4KICAgICAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzkiIGRhdGEtbmFtZT0iRWxsaXBzZSA5IiBjeD0iMiIgY3k9IjIiIHI9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkgOC4wNTkpIiBmaWxsPSIjZTdiOTQwIiBzdHJva2U9IiMyYzI3MWMiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgICA8ZyBpZD0iXzMwLWZpbHRlcnMtMiIgZGF0YS1uYW1lPSIzMC1maWx0ZXJzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNS41IDMwKSI+CiAgICAgIDxnIGlkPSJHcm91cF8zMzc2LTIiIGRhdGEtbmFtZT0iR3JvdXAgMzM3NiI+CiAgICAgICAgPGxpbmUgaWQ9IkxpbmVfMTM3LTIiIGRhdGEtbmFtZT0iTGluZSAxMzciIHgxPSIxMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAyKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMmMyNzFjIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfOS0yIiBkYXRhLW5hbWU9IkVsbGlwc2UgOSIgY3g9IjIiIGN5PSIyIiByPSIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2LjUpIiBmaWxsPSIjZTdiOTQwIiBzdHJva2U9IiMyYzI3MWMiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
export { SvgFilterIcon as ReactComponent };